import StarterKit from '@tiptap/starter-kit';
import { TextStyleKit } from '@tiptap/extension-text-style';
import { TableKit } from '@tiptap/extension-table';
import TextAlign from '@tiptap/extension-text-align';
import type { AnyExtension } from '@tiptap/core';

import { ImagePlaceholderNode } from '~/components/document-editor/editor-image-placeholder';
import { CustomImage } from '~/components/document-editor/editor-image-extension';

import './editor-types';

import { DivNode, TextDivNode } from './extensions/div-node';
import { PageBreakNode } from './extensions/page-break-node';
import { SectionNode } from './extensions/section-node';
import { SpanNode } from './extensions/span-node';
import { CommentHighlightExtension } from './extensions/comment-highlight';
import { HeadingRoles } from './extensions/heading-roles';
import { PageFurnitureExtension } from './extensions/page-furniture';
import { PageGuide } from './extensions/page-guide';
import { StyleNode } from './extensions/style-node';
import { SvgNode } from './extensions/svg-node';
import { StyleAttributeExtension } from './extensions/style-attribute-extension';
import { SmartHighlightExtension } from './extensions/smart-highlight-extension';
import { TableRowInheritance } from './extensions/table-row-inheritance';
import { DocumentTable, TableMarkupExtension } from './extensions/table-markup-extension';
import { DataAttributesExtension } from './extensions/data-attributes-extension';
import { FontSize } from './extensions/font-size-mark';
import { TemplateSlotPreview } from './extensions/template-slot-preview';

/** Register every TipTap extension used by the HTML document editor. */
export const buildEditorExtensions = (scopeId: string): AnyExtension[] =>
  [
    StarterKit.configure({ link: { openOnClick: false } }),
    TableKit.configure({ table: false }),
    DocumentTable,
    TextStyleKit,
    TextAlign.configure({
      types: ['heading', 'paragraph', 'image', 'textDiv']
    }),
    ImagePlaceholderNode,
    DivNode,
    TextDivNode,
    SectionNode,
    SpanNode,
    PageBreakNode,
    CustomImage,
    StyleNode.configure({
      scopeId
    }),
    SvgNode,
    StyleAttributeExtension,
    TableMarkupExtension,
    DataAttributesExtension,
    TableRowInheritance,
    SmartHighlightExtension,
    FontSize,
    TemplateSlotPreview.configure({ compact: false }),
    HeadingRoles,
    // Boundaries come from the render the reader will receive, and one the render could not
    // confirm is not drawn at all — a gutter on the wrong line is worse than no gutter.
    PageGuide,
    PageFurnitureExtension,
    CommentHighlightExtension
  ] as AnyExtension[];
